export const UserRole = {
    CONSUMER: "consumer",
    SUPPLIER: "supplier",
    ADMIN: "admin",
    SUPER_ADMIN:'super_admin'
  };